import i18next from "../i18n";
import { extractApiError } from "./apiError";

/**
 * Turns anything thrown by a request into text for the user, in their language.
 *
 * - With a backend `code`: the `errors.<code>` translation (the backend's `params` fill its
 *   placeholders). If that key does not exist yet, i18next returns the default instead: the
 *   backend's own message, else `opts.fallbackKey`, else `errors.generic`.
 * - Without a code: the backend's message when it sent one.
 * - Without a code or message: `errors.network` when the request never got a response,
 *   otherwise `opts.fallbackKey` (when given) or `errors.generic`.
 */
export const translateApiError = (
  error: unknown,
  opts?: { fallbackKey?: string }
): string => {
  const { status, code, message, params } = extractApiError(error);

  const fallback = (): string => {
    if (message) return message;
    if (status === null) return i18next.t("errors.network");
    return i18next.t(opts?.fallbackKey ?? "errors.generic");
  };

  if (code) {
    return i18next.t(`errors.${code}`, { ...params, defaultValue: fallback() });
  }
  return fallback();
};
